import { takeEvery } from 'modules/typed-saga';
import { actionStockGet } from 'store/stocks/actions';
import { workerErrorNotifyThunk } from 'utils/sagas';

export const sagasStocks = [takeEvery([actionStockGet.rejected], workerErrorNotifyThunk)];
